export default __webpack_public_path__ + "static/media/app_vigor.dfe47722.svg";